import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const firstColumn = [
    {
        name: "Why Sunday School Still Matters in Today’s World",
        link: "/blogs/why-sunday-school-still-matters"
    },
    {
        name: "Raising the Next Generation of Faith Through Sunday School",
        link: "/blogs/raising-next-generation-of-faith"
    },
    {
        name: "How Early Spiritual Education Shapes Lifelong Believers",
        link: "/blogs/early-spiritual-education"
    },
    {
        name: "Behind the Scenes: The Heart of a Sunday School Teacher",
        link: "/blogs/heart-of-sunday-school-teacher"
    },
];

const secondColumn = [
    {
        name: "About Us",
        link: "/about-us"
    },
    {
        name: "Contact",
        link: "/contact-us"
    },
    {
        name: "Help",
        link: "/help"
    },
];

const thirdColumn = [
    {
        name: "Privacy Policy",
        link: "/privacy-policy"
    },
    {
        name: "Terms & Conditions",
        link: "/terms-and-conditions"
    },
];


export const Footer = () => {

    return (
        <>
            <footer className="bg-[#FAFAFA] py-8 px-6 md:px-10">
                <div className="w-full grid grid-cols-1 md:grid-cols-5 gap-10">
                    {/* Brand Info */}
                    <div>
                        <div className="mb-2">
                            <img className="w-[80px]" src="/images/logo-backgroundless.png" alt="logo" />
                        </div>
                        <p className="text-gray-600 text-sm">
                            Online learning you can access <br /> anywhere easily
                        </p>
                    </div>

                    <div className="md:col-span-1 max-w-[250px]">
                        <h4 className="font-semibold mb-4">Blogs</h4>
                        <ul className="space-y-2 text-sm text-primary">
                            {firstColumn.map((item, index) => (
                                <li
                                    key={index}
                                    className="border-b border-transparent hover:border-primary text-gray-500 hover:text-primary break-words"
                                >
                                    <Link to={item.link}>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-4">Our Company</h4>
                        <ul className="space-y-2 text-sm text-primary">
                            {secondColumn.map((item, index) => (
                                <li key={index} className="w-max border-b border-transparent hover:border-primary text-gray-500 hover:text-primary">
                                    <Link to={item.link}>
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Legal</h4>
                        <ul className="space-y-2 text-sm text-primary">
                            {thirdColumn.map((item, index) => (
                                <li key={index} className="w-max border-b border-transparent hover:border-primary text-gray-500 hover:text-primary">
                                    <Link to={item.link}>
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>


                </div>

                {/* Bottom Section */}
                <div className="border-t mt-12 pt-6 text-sm text-gray-500">
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <div className="w-full md:w-auto text-center md:flex-1">
                            <span>
                                &copy; 2025 Sunday School {' '}
                            </span>
                            <a
                                href="https://jjeve.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary hover:underline"
                            >

                            </a>

                            <span> | All Rights Reserved.</span>
                        </div>

                        <div className="flex justify-center md:justify-end gap-4 w-full md:w-auto mt-4 md:mt-0">
                            <FaFacebookF />
                            <FaXTwitter />
                            <FaInstagram />
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}